import React, {
  forwardRef,
  useState,
  useEffect,
  useImperativeHandle,
} from "react";
import TocDropdown from "../../../generic/tocDropdown";
import { IListObj } from "../../../types/genericTypes";
import { NomineeGuardianForm } from "./addNominee/form";
import { NOOFNOMINEE, NOMINEE } from "./addNominee/constant";
import LoginService,{getinvAccDet} from "../../../service/login/loginService";
import { AccounTypeSection } from "./common/accountTypeSection";
import { ShowDetails } from "./addNominee/showDetails";
import Loader from "../../../generic/loader";
import { DpTrading } from "./common/dpTrading";
import { GetPersonDetails } from "../../../service/serviceRequest/srApiService";
import RadioButton from "../../../generic/radioButton";

const dispType: Array<IListObj> = [
  { value: "dispNomDec", display: "Display nomination declaration" },
  { value: "dispNomNames", display: "Display nominee names" },
];

export const AddNewNominee = forwardRef((props: any, ref: any) => {
  const [accountCode, setAccountCode] = useState<any>();
  const [dpOptions, setDpOptions] = useState<IListObj[]>();
  const [selectedDp, setSelectedDp] = useState<string>("");
  const [totalNominee, setTotalNominee] = useState<any>([NOMINEE]);
  const [selectedAcc, setSelectedAcc] = useState<any>("tradingDemat");
  const [selectedInvAcc, setSelectedInvAcc] = useState<any>("investmentDemat");
  const [isGuardianAvailable, setIsGuardianAvailable] =
    useState<boolean[]>([false,false,false]);
  const [GuardianData, setGuardianData] = useState<any>([]);
  const [sameGuardian, setSameGuardian] = useState<boolean | undefined>(
    undefined
  );
  const [jointHolderErrorMsg, setJointHolderErrorMsg] = useState<any>("");
  const [updateShowDetails, setUpdateShowDetails] = useState<boolean>(false);
  const [loader, setLoader] = useState<boolean>(false);
  const [userPan, setUserPan] = useState<string>("");
  const [DPType, setDPType] = useState<string>("");
  const [errors, setErrors] = useState<any>({
  });
  // const [nominationNameDisplayFlag, setNominationNameDisplayFlag] = useState<boolean>(false);
  // const [nominationFlag, setNominationFlag] = useState<boolean>(false);
  const [displayOption, setDisplayOption] = useState<any>("dispNomDec");

  const nomineeRef: any = [];
  const guardianRef: any = [];
  let invOnlyAcc = getinvAccDet();

  useEffect(() => {
    if (
      props.nomineeDet[0].DematDetails &&
      props.nomineeDet[0].DematDetails.length > 0
    ) {
      let selectedDpElement = props.nomineeDet[0].DematDetails.find(
        (ele: any) => {
          if (ele.Demat_Account_Number === selectedDp) return ele;
        }
      );

      if (selectedDpElement && selectedDpElement.Demat_HolderType) {
        if (selectedDpElement.Demat_HolderType === "Joint") {
          props.enableSubmit(false);
          setJointHolderErrorMsg(
            "It seems that the DP Account is a joint holder account. This request cannot be processed online."
          );
        } else {
          setJointHolderErrorMsg(undefined);
        }
      }
    }
  }, [selectedDp]);
  useEffect(() => {
    if (selectedDp)
      setDPType(
        selectedAcc === "trading"
          ? ""
          : selectedDp.includes("IN")
          ? "NSDL"
          : "CDSL"
      );
  }, [selectedDp, selectedAcc]);

  useEffect(() => {
    getPersonalDetails();
    setDpDetails(props.nomineeDet[0].DematDetails);

    if (
      props.nomineeDet[0].TradingDetails &&
      props.nomineeDet[0].TradingDetails.AccountCode
    )
      setAccountCode(props.nomineeDet[0].TradingDetails.AccountCode);
  }, [props.nomineeDet]);

  const setDpDetails = (dematDet: any) => {
    let dpOptions: any = [];

    dematDet.forEach((ele: any) => {
      if (ele.DematTagging !== "OUTSIDE_DP") {
        if (dpOptions.length === 0) {
          dpOptions.push({
            display: "Select DP Details",
            value: "",
          });
        }
        dpOptions.push({
          display: ele.Demat_Account_Number,
          value: ele.Demat_Account_Number,
          ...ele,
        });
      }
    });
    if (dpOptions.length > 2) {
      setDpOptions(dpOptions);
      // setDpToReplicate(dpOptions[1]);
    } else if (dpOptions.length === 2) {
      setDpOptions(dpOptions);
      setSelectedDp(dpOptions[1].value);
    }
    //dp
  };

  useEffect(() => {
    let guardpresent = [false,false,false];
    if (totalNominee.length > 1) {
      setUpdateShowDetails(!updateShowDetails);
      for (let i = 0; i < totalNominee.length - 1; i++) {
        if (totalNominee[i].minor) {
          guardpresent[i+1] = true;
        }
      }
      setIsGuardianAvailable(guardpresent);
    }
  }, [totalNominee]);

  useEffect(() => {
    let expetedGurdian = [];
    if (totalNominee.length > 1 && typeof sameGuardian === "boolean") {
      for (let i = 0; i < totalNominee.length - 1; i++) {
        if (expetedGurdian.length > 0) {
          for (let j = 0; j < expetedGurdian.length; j++) {
            if (
              expetedGurdian[j]?.firstName !== totalNominee[i].guard.firstName
            ) {
              expetedGurdian.push(totalNominee[i].guard);
              setGuardianData(expetedGurdian);
            }
          }
        } else if(totalNominee[i].guard){
          expetedGurdian.push(totalNominee[i].guard);
          setGuardianData(expetedGurdian);
        }
      }
      setSameGuardian(undefined);
    }
  }, [sameGuardian, updateShowDetails]);

  async function getPersonalDetails() {
    let personaldetails = await GetPersonDetails();
    if (personaldetails && personaldetails.pANNumberField) {
      setUserPan(personaldetails.pANNumberField);
    } else {
      setUserPan("");
    }
  }

  useImperativeHandle(ref, () => ({
    submitData() {
      const nomineeVal = nomineeRef.map((x: any) => x.validation());
      const guardVal = guardianRef.map((x: any) => x.validation());
      const validation = [...nomineeVal, ...guardVal].every((x) => typeof x == 'boolean' ? x : true);
      const accValidation =
        selectedAcc === "trading"
          ? true
          : selectedDp
          ? (() => {
              setErrors({ ...errors, dp: "" });
              return true;
            })()
          : (() => {
              setErrors({ ...errors, dp: "Please select DP Id" });
              return false;
            })();
      if (validation && accValidation && !invOnlyAcc) {
        let dpId = selectedDp;

        if (!selectedDp || selectedAcc === "trading") {
          //if only trading visible/ trading option selected
          if (props.nomineeDet)
            props.nomineeDet[0].DematDetails.forEach((ele: any) => {
              if (ele.DefaultDemat === "Yes") dpId = ele.Demat_Account_Number;
            });
        }
        let nomTyp = "Modification";
        let minorClient = "No";
        props.nomineeDet[0].DematDetails.forEach((ele: any) => {
          if (ele.Demat_Account_Number === dpId) {
            nomTyp =
              ele.Nominee_Details.length > 0 ? "Modification" : "Addition";
            if (ele.Minor && ele.Minor.trim()) minorClient = ele.Minor;
          }
        });
        let status = "Approved";
        let nominees = totalNominee.map((ele: any) => {
          if (
            ele.hasOwnProperty("attachment") &&
            ele.attachment.nm &&
            ele.attachment.docType !== "PhotographAndSignature"
          )
            if (!ele.qcFlag) status = "QCPending";

          if (ele.hasOwnProperty("attachment") && !ele.attachment.nm)
            delete ele.attachment;
          if (ele.hasOwnProperty("guard") && ele.guard) {
            if (
              ele.guard.hasOwnProperty("attachment") &&
              ele.guard.attachment.nm &&
              ele.guard.attachment.docType !== "PhotographAndSignature"
            )
              if (!ele.guard.qcFlag) status = "QCPending";
            if (
              ele.guard.hasOwnProperty("attachment") &&
              !ele.guard.attachment.nm
            )
              delete ele.guard.attachment;
          }
          if (ele.lastName === "") {
            ele.lastName = ".";
          }

          if (ele.address) {
            Object.keys(ele.address).map((k) => {
              if (k.includes("addr")) {
                if (ele.address[k].length < 5) {
                  let str = "";
                  for (let i = 0; i < 5 - ele.address[k].length; i++) {
                    str += "-";
                  }
                  ele.address[k] += str;
                }
              }
            });
          }
          if (ele.hasOwnProperty("guard")) {
            if (ele.guard.lastName === "") {
              ele.guard.lastName = ".";
            }
            Object.keys(ele.guard.address).map((k) => {
              if (k.includes("addr")) {
                if (ele.guard.address[k].length < 5) {
                  let str = "";
                  for (let i = 0; i < 5 - ele.guard.address[k].length; i++) {
                    str += "-";
                  }
                  ele.guard.address[k] += str;
                }
              }
            });
          }

          return ele;
        });
        return {
          acTyp: LoginService.getAccData("accTyp"),
          dpId,
          // trdOpt: false,
          // dpOpt: false,
          trdUpd: selectedAcc.includes("trading"),
          dpUpd: selectedAcc.toLowerCase().includes("demat"),
          reqTyp:
            (selectedAcc === "tradingDemat" && "trading+demat") ||
            (selectedAcc === "trading" && "trading") ||
            (selectedAcc === "demat" && "demat"),
          nomTyp,
          subStatus: status,
          minorClient: minorClient,
          nominationNameDisplayFlag: displayOption == "dispNomNames" ? true : false,
          nominationFlag: displayOption == "dispNomDec" ? true : false,
          nominees: nominees,
          firstHolderSignature: localStorage.getItem("signature") || ""
        };
      }
      else if (validation && invOnlyAcc) {
        let dpId = selectedDp;

        if (!selectedDp || selectedAcc === "trading") {
          //if only trading visible/ trading option selected
          if (props.nomineeDet)
            props.nomineeDet[0].DematDetails.forEach((ele: any) => {
              if (ele.DefaultDemat === "Yes") dpId = ele.Demat_Account_Number;
            });
        }
        let nomTyp = "Addition";
        let minorClient = "No";
        let status = "Approved";
        let nominees = totalNominee.map((ele: any) => {
          if (
            ele.hasOwnProperty("attachment") &&
            ele.attachment.nm &&
            ele.attachment.docType !== "PhotographAndSignature"
          )
            if (!ele.qcFlag) status = "QCPending";

          if (ele.hasOwnProperty("attachment") && !ele.attachment.nm)
            delete ele.attachment;
          if (ele.hasOwnProperty("guard") && ele.guard) {
            if (
              ele.guard.hasOwnProperty("attachment") &&
              ele.guard.attachment.nm &&
              ele.guard.attachment.docType !== "PhotographAndSignature"
            )
              if (!ele.guard.qcFlag) status = "QCPending";
            if (
              ele.guard.hasOwnProperty("attachment") &&
              !ele.guard.attachment.nm
            )
              delete ele.guard.attachment;
          }
          if (ele.lastName === "") {
            ele.lastName = ".";
          }

          if (ele.address) {
            Object.keys(ele.address).map((k) => {
              if (k.includes("addr")) {
                if (ele.address[k].length < 5) {
                  let str = "";
                  for (let i = 0; i < 5 - ele.address[k].length; i++) {
                    str += "-";
                  }
                  ele.address[k] += str;
                }
              }
            });
          }
          if (ele.hasOwnProperty("guard")) {
            if (ele.guard.lastName === "") {
              ele.guard.lastName = ".";
            }
            Object.keys(ele.guard.address).map((k) => {
              if (k.includes("addr")) {
                if (ele.guard.address[k].length < 5) {
                  let str = "";
                  for (let i = 0; i < 5 - ele.guard.address[k].length; i++) {
                    str += "-";
                  }
                  ele.guard.address[k] += str;
                }
              }
            });
          }

          return ele;
        });
        return {
          requestType: "Nomination",
          acTyp: LoginService.getAccData("accTyp"),
          dpId,
          trdUpd: selectedAcc.includes("trading"),
          dpUpd: selectedAcc.toLowerCase().includes("demat"),
          reqTyp: "Investment",
          nomTyp,
          subStatus: status,
          minorClient: minorClient,
          nominationNameDisplayFlag: displayOption == "dispNomNames" ? true : false,
          nominationFlag: displayOption == "dispNomDec" ? true : false,
          nominees: nominees,
          firstHolderSignature: localStorage.getItem("signature") || ""
        };
      }
      else {
        (
          document.getElementsByClassName("modal-Sr")[0] as HTMLDivElement
        ).scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth",
        });
        return false;
      }
    },
  }));
  const NomineeForm = () => {
    return (
      <div className="dpDetailsWrap nomineeWrap-first">
        {totalNominee?.length > 0 &&
          totalNominee.map((no: any, i: any) => {
            return (
              <div key={i}>
                <NomineeGuardianForm
                  type={1}
                  id={i}
                  updateNominee={setTotalNominee}
                  nominee={totalNominee}
                  accountCode={accountCode}
                  userPan={userPan}
                  isGuardianAvailable={isGuardianAvailable[i]}
                  setSameGuardian={setSameGuardian}
                  sameGuardian={sameGuardian}
                  setLoader={props.setLoader}
                  key={i}
                  ref={(ref) => (nomineeRef[i] = ref)}
                  enableSubmit={props.enableSubmit}
                  dpType={DPType}
                  // nominationFlag={nominationFlag}
                  // setNominationFlag={setNominationFlag}
                  // nominationNameDisplayFlag={nominationNameDisplayFlag}
                  // setNominationNameDisplayFlag={setNominationNameDisplayFlag}
                  // displayOption={displayOption}
                  // setDisplayOption={setDisplayOption}
                />
                {no.minor && (
                  <div>
                    {no.sameas ? (
                      <ShowDetails
                        totalNominee={totalNominee}
                        setTotalNominee={setTotalNominee}
                        GuardianData={GuardianData}
                        id={i}
                        key={i}
                      />
                    ) : (
                      <NomineeGuardianForm
                        type={2}
                        id={i}
                        userPan={userPan}
                        accountCode={accountCode}
                        updateNominee={setTotalNominee}
                        nominee={totalNominee}
                        setLoader={props.setLoader}
                        key={i}
                        ref={(ref) => (guardianRef[i] = ref)}
                        enableSubmit={props.enableSubmit}
                        dpType={DPType}
                      />
                    )}
                  </div>
                )}
              </div>
            );
          })}
        <div style={{ display: invOnlyAcc ? 'none' : 'block' }}>
           <hr/>
          <div className="msg mg-b10">
            <div className="blue-text">Would you like the nomination details to be displayed in the statement
              of holdings issued by the Asset Management Company (AMC) or Depository Participant (DP)?
            </div>
          </div>
          <div className="radioBtn_wrap">
            <RadioButton
              list={dispType[0]}
              name="nominationFlag"
              onChange={() => {
                setDisplayOption(dispType[0].value)
              }}
              moduleName="nominationOptional"
              selected={displayOption}
            />
          </div>
          <div className="radioBtn_wrap">
            <RadioButton
              list={dispType[1]}
              name="nominationNameDisplayFlag"
              onChange={() => {
                setDisplayOption(dispType[1].value)
              }}
              moduleName="nominationOptional"
              selected={displayOption}
            />
          </div>
        </div>

        <div style={{ display: invOnlyAcc ? 'block' : 'none' }}>
          <hr />
          <p className="text-indicator small--text-indicator noSpaceIndicator space-mt-2 red_text">Note:
            <span className="pd-l45">
              <ul className="circle-list marker-mg-r10 font-RobotoCR pd-l45">
                <li className="font-18 red"><span className="font-12 red_text">For Fresh MF folio created on BSE Star MF, new nominee details will only be considered.</span></li>
                <li className="font-18 red"><span className="font-12 red_text">For existing folio, Client will have to get the new nominee details updated with the respective Mutual Funds separately.</span></li>
              </ul>
            </span>
          </p>
        </div>
                
      </div>
    );
  };

  return (
    <>
      <div className="addNominee">
        {/* <div className="msg">
          <p className="blue-text">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed metus
            nunc, accumsan ultricies orci eget, maximus tristique leo.
          </p>
        </div> */}
        <div className="dpDetailsWrap">
          <div>
            <h6 className="addNomineeDetailHead">Add Nominee Details in</h6>
          </div>
          {!jointHolderErrorMsg && !invOnlyAcc &&(
            <AccounTypeSection
              setAccountType={(val: any) => {
                setSelectedAcc(val);
                if (val === "trading") {
                  setErrors({ ...errors, dp: "" });
                  setJointHolderErrorMsg("");
                }
              }}
              onlyTrading={dpOptions && dpOptions.length === 0 ? 1 : ( props.onlyTrading === 1 ? 1 : 0)}
            />
          )}
          
          {!invOnlyAcc &&(
            <DpTrading
            dpOptions={dpOptions}
            selectedAcc={selectedAcc}
            selectedDp={selectedDp}
            setSelectedDp={setSelectedDp}
            errorMsg={jointHolderErrorMsg}
            accountCode={props.nomineeDet[0].TradingDetails.AccountCode}
            setErrors={setErrors}
            errors={errors}
          />
          )}

          <div className="custom--row tradingAccnt">
            {!jointHolderErrorMsg && (
              <div className="form-field custom-col noLeftPAdding">
                <label className="input-label">
                  How many Nominees do you want?
                </label>
                {NOOFNOMINEE && NOOFNOMINEE.length > 0 && (
                  <TocDropdown
                    selectedValue={
                      totalNominee
                        ? NOOFNOMINEE.find(
                            (n: any) => n.value === totalNominee.length
                          )?.value
                        : NOOFNOMINEE[0].value
                    }
                    dropdownOptions={NOOFNOMINEE}
                    onSelect={(value: any) => {
                      setLoader(true);
                      const nominee: any = [];
                      for (let i = 1; i <= value; i++) {
                        let nom = JSON.parse(JSON.stringify(NOMINEE));
                        const per = Math.trunc(100 / value);
                        let temp = 0;
                        temp = temp + (100 % value);
                        if (i == 1) {
                          nom.nomPer = `${per + temp}`;
                        } else {
                          nom.nomPer = `${per}`;
                        }

                        nominee.push(nom);
                      }
                      setGuardianData(undefined);
                      setSameGuardian(undefined);
                      setTotalNominee(JSON.parse(JSON.stringify(nominee)));
                      // for Rerender ther NominationForm
                      setTimeout(() => {
                        setLoader(false);
                      }, 200);
                    }}
                    isSearchable={false}
                  />
                )}
              </div>
            )}
          </div>
        </div>
        {/* {jointHolderErrorMsg && (
          <>
            <br />
            <p className="error-msg">{jointHolderErrorMsg}</p>
          </>
        )} */}
        {!jointHolderErrorMsg ? (
          !loader ? (
            <div className="nomineeWrap">{NomineeForm()}</div>
          ) : (
            <div style={{ textAlign: "center", paddingTop: "50px" }}>
              <Loader size={50} color="blue"></Loader>
            </div>
          )
        ) : (
          <></>
        )}
      </div>
      <div></div>
    </>
  );
});
